import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const SectionTitle = styled.h3`
  margin-bottom: 32px;
  font-weight: 600;
  line-height: 1.13;
  letter-spacing: -0.5px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Subheading = styled.div`
  margin: 8px 0 32px;
  font-size: 10px;
  line-height: 1.6;
  letter-spacing: 0.7px;
  color: ${ColorPalette.HEX.DimGray};
  text-transform: uppercase;
`;

export const Content = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};

  & ol,
  ul {
    list-style: inside;
  }

  & ul > li,
  ol > li,
  p {
    margin: 8px 0;
  }
`;
